import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DeviceList.scss';
import Logout from '../../../shared/Logout/Logout';
import Header from '../../../shared/Header/Header';
import crossIcon from '../Icons/cross.svg';
import imprivataIcon from '../Icons/imprivata.svg';

/**
 * Enrolled Devices List prompt
 * @class DeviceList
 * @extends {Component}
 */
class DeviceList extends Component {
  static propTypes = {
    /** Header image */
    headerImage: PropTypes.string,
    /** Header title */
    headerTitle: PropTypes.string,
    /** Header description */
    headerDescription: PropTypes.object,
    /** Link to enroll page*/
    enrollDeviceLink: PropTypes.func,
    /** Retry text*/
    retryText: PropTypes.string,
    /** Names of the devices to display*/
    devices: PropTypes.array,
    /** link to display more options */
    moreOptionsLink: PropTypes.object,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** Text to be included in the information overlay*/
    infoPopout: PropTypes.string,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    /** Link to return to IID */
    continueLink: PropTypes.object,
    /** The underlying title for the manage devices screen, separate from any banner message titles*/
    baseHeaderTitle: PropTypes.string,
    /** Type of message from list successMSG, deleteMSG*/
    messageType: PropTypes.string,
    headerType: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  static defaultProps = {
    devices: [],
    headerTitle: 'Manage devices',
    logoutComponent: <Logout />,
    baseHeaderTitle: 'Manage devices',
    messageType: null,
    // Parkland custom UX
    useCustomUX: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }
  doesInclude(list, element) {
    return list.indexOf(element) !== -1;
  };

  animateBannerReset() {
    const banner = document.querySelector('.Message-Header-Box');

    if (banner != null) {
      banner.animate([
        {
          transformOrigin: 'top left',
          transform: 'none',
        },
        {
          transformOrigin: 'top left',
          transform: `
              translateX(0px)
              translateY(0px)
              scale(1)
              `,
        },
      ], {
        duration: 750,
        easing: 'ease-in-out',
        fill: 'both',
      });
    }
  };

  animateBanner() {
    const banner = document.querySelector('.Message-Header-Box');
    if (banner != null) {
      const start = banner.getBoundingClientRect();

      banner.animate([
        {
          transformOrigin: 'top left',
          transform: 'none',
        },
        {
          transformOrigin: 'top left',
          transform: `
              translateX(0px)
              translateY(-${start.height}px)
              scale(1)
              `,
        },
      ], {
        duration: 750,
        easing: 'ease-in-out',
        fill: 'both',
      });
    }
  };

  componentDidMount() {
    if (this.props.messageType != null) {
      setTimeout(this.animateBanner, 4000);
    }
  };

  componentDidUpdate() {
    clearTimeout(0);
    this.animateBannerReset();
    setTimeout(this.animateBanner, 4000);
  };

  render() {
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        {this.props.useCustomUX && <Header />}
        {(this.props.headerType && !this.props.useCustomUX) && (
          <div className={this.props.headerType}>
            <div className='Message-Header-Text'>
              <span>{this.props.headerTitle}</span>
            </div>
            <div className='Message-Header-Description'>
              <span>{this.props.headerDescription}</span>
            </div>
          </div>
        )}
        {(!this.props.headerType && !this.props.useCustomUX) && (
          <div className='Header-Box'>
            <div className='Header-Text'>
              <span>{this.props.baseHeaderTitle}</span>
            </div>
            <div className='Header-Description'>
            </div>
          </div>)}
        {this.props.enrollDeviceLink && (
          <div>
            <div className='Enroll-New-Device'>
              <span className='Enroll-New-Device-Text' onClick={this.props.enrollDeviceLink}>Enroll new device</span>
            </div>
            <div className='Enroll-New-Device-Circle btn' onClick={this.props.enrollDeviceLink} />
            <img className='Enroll-New-Device-Cross' src={crossIcon} onClick={this.props.enrollDeviceLink} alt='cross' />
          </div>
        )}
        <div>
          <div className='Current-Devices'>
            <span className='Current-Devices-Text'>YOUR CURRENT DEVICES</span>
          </div>
        </div>
        {this.props.devices.map(device =>
          <div className='Modality-Block' key={device.serialNumber}>
            <div className='Device-Modality-Text'>
              <span className=''>{device.displayName}</span>
              <br />
              <span className='device-description'>{(this.doesInclude(device.serialNumber, 'IMPR') !== -1) ? 'Imprivata ID' : device.serialNumber}</span>
            </div>
          </div>)}
        {this.props.footer}
        <div className='continueLink btn-link'>
          {this.props.continueLink}
        </div>
        <div>
          <hr className='Footer-hr' />
          <img className='Footer' src={imprivataIcon} alt='logo' />
        </div>
      </div>
    );
  }
}

export default DeviceList;
